module.exports = __webpack_public_path__ + "images/back@3x.png?9d21a342";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/back@3x.png
// module id = 599
// module chunks = 7